const menuJson = {
  // 个人中心
  personalCenterList: [
    {
      name: 'PersonalCenter', // 个人中心
      hasChildList: false,
      href: '/personalCenter/information',
      menuLogo: 'icon-user-01'
    }
  ],
  // 成员管理
  memberManageList: [
    {
      name: 'MemberManage', // 成员管理
      hasChildList: false,
      href: '/memberManage/memberManage',
      menuLogo: 'icon-investigation-01'
    },
    {
      name: 'MemberGroupManage', // 成员组管理
      hasChildList: false,
      href: '/memberManage/memberGroupManage',
      menuLogo: 'icon-managements-01'
    }
  ],
  // 任务大厅
  taskHall: [
    {
      name: 'PublicTask', // 公共任务
      matchName: '公共任务',
      hasChildList: false,
      href: '/taskHall/publicTask',
      menuLogo: 'icon-batch-01'
    },
    {
      name: 'DesignateTask', // 指派任务
      hasChildList: false,
      matchName: '指派任务',
      href: '/taskHall/designateTask',
      menuLogo: 'icon-contract-01'
    },
    {
      name: 'MyTask', // 我的任务
      hasChildList: false,
      matchName: '我的任务',
      href: '/taskHall/myTask',
      menuLogo: 'icon-task-02'
    },
    {
      name: 'AllTask', // 全部任务
      hasChildList: false,
      matchName: '全部任务',
      href: '/taskHall/allTasks',
      menuLogo: 'icon-material-01'
    }
  ],
  // 线索
  clueList: [
    {
      name: '外部线索报审', // 外部线索报审
      hasChildList: true,
      matchName: '外部线索报审',
      herf: '',
      menuLogo: 'icon-case-02',
      childList: [
        {
          name: '线索预审', // 线索预审
          hasChildList: false,
          href: '/clue/preReport',
          menuLogo: ''
        },
        {
          name: '全部线索', // 全部线索
          hasChildList: false,
          href: '/clue/allReport',
          menuLogo: ''
        }
      ]
    },
    {
      name: 'MyResult', // 我的线索
      hasChildList: false,
      matchName: '我的线索',
      href: '/clue/myClue',
      menuLogo: 'icon-clue-01'
    },
    {
      name: 'AllResult', // 全部线索
      hasChildList: false,
      matchName: '全部线索',
      href: '/clue/allClues',
      menuLogo: 'icon-channel-01'
    }
  ],
  // 案件
  caseList: [
    {
      name: '民事案件',
      hasChildList: true,
      matchName: '民事案件', // 民事案件
      href: '',
      menuLogo: 'icon-case-02',
      childList: [
        {
          name: '普通案件', // 民事案件
          hasChildList: false,
          href: '/case/civilCase',
          menuLogo: ''
        }, {
          name: '取证案件', // 行政案件
          hasChildList: false,
          href: '/case/obtainEvidenceCase',
          menuLogo: ''
        }, {
          name: '重案案件', // 重案案件
          hasChildList: false,
          href: '/case/seriousCase',
          menuLogo: ''
        }
      ]
    },
    {
      name: '行政案件',
      hasChildList: false,
      href: '/case/administrativeCase',
      menuLogo: 'icon-case-03'
    },
    {
      name: '刑事案件',
      hasChildList: false,
      href: '/case/criminalCase',
      menuLogo: 'icon-case-03'
    },
    {
      name: 'AllCases', // 全部案件
      hasChildList: false,
      matchName: '全部案件',
      href: '/case/allCases',
      menuLogo: 'icon-case-03'
    },
    {
      name: '已转出案件',
      hasChildList: false,
      matchName: '已转出案件',
      href: '/case/transferredCases',
      menuLogo: 'icon-send-back-01'
    }
  ],
  // 结算
  settlementList: [
    {
      name: '待结算案件',
      hasChildList: false,
      matchName: '待结算案件',
      href: '/case/unsettledCase',
      menuLogo: 'icon-case-02'
    },
    {
      name: '结算单管理',
      hasChildList: false,
      matchName: '结算单管理',
      href: '/case/statementManagement',
      menuLogo: 'icon-case-03'
    },
    {
      name: '退款管理',
      hasChildList: false,
      matchName: '退款管理',
      href: '/case/refundManagement',
      menuLogo: 'icon-case-02'
    },
    {
      name: '收款记录',
      hasChildList: false,
      matchName: '收款记录',
      href: '/case/collectionRecord',
      menuLogo: 'icon-case-03'
    },
    {
      name: '邮寄列表',
      hasChildList: false,
      matchName: '邮寄列表',
      href: '/settlement/mailingList',
      menuLogo: 'icon-case-02'
    }
  ],
  // 项目
  projectList: [
    {
      name: 'project', // 项目
      hasChildList: false,
      href: '/project/list',
      menuLogo: 'icon-project-03'
    }
  ],
  // 系统设置
  settingsList: [
    {
      name: 'teamInfo', // 团队信息
      hasChildList: false,
      href: '/settings/teamInfo',
      menuLogo: 'icon-organization-01'
    },
    {
      name: 'authority', // 权限管理
      hasChildList: false,
      href: '/settings/authority',
      menuLogo: 'icon-agreement-04'
    },
    {
      name: 'bankCardAccount', // 银行卡账户
      hasChildList: false,
      href: '/settings/bankCardAccount',
      menuLogo: 'icon-card-01'
    },
    {
      name: 'mailingAddress', // 邮寄地址
      hasChildList: false,
      href: '/settings/mailingAddress',
      menuLogo: 'icon-project-02'
    }
  ]
}

export default {
  menuJson
}



// WEBPACK FOOTER //
// ./src/libs/menu.js